import React from 'react';

export default ({ className, ...other }) => (
  <svg
    {...other}
    className={`icon w16 ${className || ''}`}
    viewBox="0 0 39.466 39.466"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group_50" data-name="Group 50" transform="translate(-494.046 -402.669)">
      <g id="Group_48" data-name="Group 48">
        <path id="Path_2" data-name="Path 2" d="M513.779,442.135A19.733,19.733,0,1,1,533.512,422.4,19.755,19.755,0,0,1,513.779,442.135Zm0-37.466A17.733,17.733,0,1,0,531.512,422.4,17.753,17.753,0,0,0,513.779,404.669Z" fill="currentColor" />
      </g>
      <g id="Group_49" data-name="Group 49">
        <path id="Path_3" data-name="Path 3" d="M516.376,431.44a.993.993,0,0,1-.707-.293l-7.2-7.2a2.026,2.026,0,0,1,.028-2.9c2.007-1.92,7.223-7.332,7.275-7.386a1,1,0,0,1,1.44,1.387c-.215.223-5.3,5.5-7.331,7.443l7.2,7.233a1,1,0,0,1-.707,1.707Z" fill="currentColor" />
      </g>
    </g>
  </svg>
);
